const states = require('us-state-converter');
import { Loader } from 'google-maps';

let allMarkers = [];

export default (preState = null, apiKey = null, preVisa = null) => ({
  name: 'LocationsMap',
  // * data()
  start: false,
  ready: false,
  selectedState: '',
  selectedLocationsType: '',
  selectedAcademics: false,
  selectedVisa: false,
  locations: [],
  filteredLocations: [],
  expanded: true,
  desktop: window.innerWidth >= 992 ? true : false,
  states: [],
  baseEndpoint: `${window.location.origin}/api/v1/locations`,
  constants: {
    VERSION: 'quarterly',
    API_KEY: apiKey,
  },
  markers: [],
  map: null,
  google: null,
  async init() {
    this.expanded = true;
    const res = await fetch(this.baseEndpoint);
    this.locations = await res.json();
    this.filteredLocations = this.locations;
    this.states = this.makeStatesSelectField();
    if (preState) {
      this.selectedState = preState;
    } else if (window.location.search) {
      this.selectedState = window.location.search.split('=')[1];
    }

    if (preVisa) {
      this.selectedVisa = (preVisa == 1) ? true : false;
    }

    if (this.constants.API_KEY) {
      this.filterLocations();
    }
  },
  makeStatesSelectField() {
    const regionStates = this.filteredLocations.map((location) => location.regionStates.split(', '));
    const states = this.filteredLocations.map((location) => location.state);
    const combinedStates = states.concat(regionStates.flat()).filter((item) => item !== '');
    const uniqueStates = [...new Set(combinedStates)];
    const statesWithAbbr = uniqueStates.map((state) => {
      return {
        name: this.stateCodeToName(state),
        code: state,
      };
    });

    statesWithAbbr.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    this.ready = true;
    return statesWithAbbr;
  },
  stateCodeToName(code) {
    if (code === '' || code === 'any') {
      return 'all States';
    }
    return states.fullName(code);
  },
  async filterLocations() {
    let state = this.selectedState === 'any' || '' ? '' : this.selectedState;
    //let type = this.selectedLocationsType === 'any' || '' ? '' : this.selectedLocationsType;
    let academics = this.selectedAcademics;
    let visa = this.selectedVisa;

    const filteredLocations = this.locations.filter((location) => {
      if (state !== '' && this.selectedState !== location.state) {
        return false;
      }
      /*if (type !== '' && !(type == 'academics' && location.iPadMapFilters.indexOf('Academics') !== -1)) {
        return false;
      }*/
      if (academics == true && location.iPadMapFilters.indexOf('Academics') === -1) {
        return false;
      }
      if (visa == true && location.j1visa == 0) {
        return false;
      }

      return true;
    });
    this.filteredLocations = filteredLocations;

    if (!this.start && this.desktop && this.constants.API_KEY) {
      const loader = new Loader(this.constants.API_KEY, {'version': this.constants.VERSION, 'libraries': ['marker']});
      this.google = await loader.load();
      this.start = true;
      this.initMap();
    }

    //if (this.filteredLocations.length > 0 && this.desktop && this.start) {
    if (this.filteredLocations.length > 0) {
      //this.addResultsToMap(this.filteredLocations);
      this.addResultsToMap(this.locations, this.filteredLocations);
    }
  },

  async initMap() {
    this.map = new this.google.maps.Map(this.$refs.map, {
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUI: true,
      scrollwheel: false,
      draggable: true,
      zoomControl: true,
      zoom: 3.4,
      minZoom: 3.5,
      maxZoom: 16,
      center: { lat: 34.0902, lng: -85.7129 },
      componentRestrictions: { country: 'us' },
      mapId: "b6dba40959965a47"
    });

    if (this.filteredLocations.length > 0) {
      this.addResultsToMap(this.locations, this.filteredLocations);
    }
  },
  addResultsToMap(dataArray, filteredArray = []) {
    this.deleteMarkers();
    this.bounds = new this.google.maps.LatLngBounds();

    dataArray.forEach((item) => {
      if (!item.lat || !item.lng) return;
      let infoWindow = null;
      infoWindow = new this.google.maps.InfoWindow({
        content: `
          <div class="pr-4 text-left max-w-[210px]">
            <a href="${item.url}" class="no-underline hover:underline">
              <h4 class="font-bold text-[14px] leading-[18px] text-secondary-500 mb-3">
                ${item.title ? item.title : ''}
              </h4>
              <p class="text-[12px] leading-[16px] text-gray-600">${item.fullAddress ? item.fullAddress : ''}</p>
            </a>
          </div>
        `,
      });

      const glyphImg = document.createElement("img");
      glyphImg.src = `${window.location.origin}/themes/fire/theme/assets/media/svgs/icon--map-pin.svg`

      const marker = new this.google.maps.marker.AdvancedMarkerElement({
        map: Alpine.raw(this.map),
        position: {lat: parseFloat(item.lat), lng:parseFloat(item.lng)},
        content: glyphImg,
        collisionBehavior: 'REQUIRED',
        gmpClickable: true,
      });
      marker.addListener('click', () => {
        if (this.prevOpenInfoWindow) {
          this.prevOpenInfoWindow.close();
        }
        this.prevOpenInfoWindow = infoWindow;
        infoWindow.open(Alpine.raw(this.map), marker);
      });
      // Zoom in on selected state pins, while retaining other pins on the map
      if (filteredArray.length > 0 && filteredArray.includes(item)) {
        this.bounds.extend({lat: parseFloat(item.lat), lng:parseFloat(item.lng)});
        //this.markers.push(marker);
        allMarkers.push(marker);
      } else if (filteredArray.length == 0) {
        this.bounds.extend({lat: parseFloat(item.lat), lng:parseFloat(item.lng)});
        //this.markers.push(marker);
        allMarkers.push(marker);
      }
    }); // end forEach

    this.addMarkersToMap();
  },
  addMarkersToMap() {
    this.setMapOnAll(Alpine.raw(this.map));
    this.fitToBounds();
  },
  setMapOnAll(map) {
    /*this.markers.forEach((marker) => {
      marker.setMap(map);
    });*/
    for (let i = 0; i < allMarkers.length; i++) {
      allMarkers[i].setMap(map);
    }
  },
  clearMarkers() {
    this.setMapOnAll(null);
  },
  deleteMarkers() {
    this.clearMarkers();
    //this.markers = [];
    allMarkers = [];
  },
  panToCoords(coords) {
    if (!this.google) return;
    const latLng = new this.google.maps.LatLng(coords.lat, coords.lng);
    this.map.panTo(latLng);
  },
  fitToBounds() {
    this.map.fitBounds(this.bounds);
    if (window.innerWidth <= 1024) {
      setTimeout(() => {
        this.map.panBy(-85, 15);
      }, 300);
    } else {
      this.map.panToBounds(this.bounds);
    }
  },
});
